export const iconButtonHook = 'dashboard-icon-button';
export const iconButtonTooltipHook = 'dashboard-icon-button-tooltip';
